<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Password Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-card-title class="py-0">
              <v-flex xs9> </v-flex>
              <v-flex xs3 class="text-right">
                <v-icon @click="getData()">refresh</v-icon>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-flex xs12>
                <v-row class="px-5">
                  <v-flex xs6>
                    <ValidationProvider
                      name="day"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="darkblue--text pl-1">
                        <b>Change Password Notification (Days)</b>
                      </label>
                      <v-text-field
                        class="mt-2"
                        type="number"
                        v-model="item.day"
                        placeholder="Input days"
                        outlined
                        solo
                        single-line
                        flat
                        dense
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                    <p>
                      Password expiration notification will be sent
                      {{ item.day ? item.day : 0 }} days after user change the
                      password.
                    </p>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <v-row class="px-5">
                  <v-flex xs6>
                    <ValidationProvider
                      name="minute"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="darkblue--text pl-1">
                        <b>Login Blocked Duration (Minutes)</b>
                      </label>
                      <v-text-field
                        class="mt-2"
                        type="number"
                        v-model="minutes"
                        placeholder="Input minutes"
                        outlined
                        solo
                        single-line
                        flat
                        dense
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                    <p>
                      User will automatically blocked for
                      {{ minutes ? minutes : 0 }} minutes after three failed
                      login attempts.
                    </p>
                  </v-flex>
                </v-row>
              </v-flex>
            </v-card-text>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 class="mb-5 mr-3">
                <v-btn
                  id="saveBtn"
                  color="blue darken-2"
                  class="white--text"
                  block
                  type="submit"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Password',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      timeout: null,
      days: '',
      minutes: 0,
      item: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.getChangePassword();
      await this.getLoginBlocked();
    },
    getChangePassword() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('auth/getCompability')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.item = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getLoginBlocked() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('configuration/getLoginBlock')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.minutes = data.data.minutes;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update config password?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.saveconfig();
        }
        // else if (result.dismiss === Swal.DismissReason.cancel) {
        //   this.progressDialogLoading = false;
        //   this.loading = false;
        //   Swal.fire('Cancelled', 'Your brand data has been undeleted', 'error');
        // }
      });
    },
    async saveconfig() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        let params = {
          day: this.item.day
        };
        this.$store
          .dispatch('auth/updateCompability', params)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.saveLoginBlock();
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    async saveLoginBlock() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        let params = {
          minutes: Number(this.minutes)
        };
        this.$store
          .dispatch('configuration/updateLoginBlock', params)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            console.log('dat', data);
            if (data.code === 200) {
              Swal.fire({
                title: 'Success!',
                text: 'Password Configuration has been updated succesfully.',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then(result => {
                if (result.value) {
                  this.getData();
                }
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    }
  }
};
</script>
